import { ethers } from "ethers";
import { UNIFI_RPC_URL } from "../constants/network";

// A single shared read-only provider for the whole app. Creating a new
// JsonRpcProvider per call (as the components used to) multiplies the request
// load on the public RPC and is a big contributor to 429 rate limiting.
let readProvider: ethers.JsonRpcProvider | null = null;

export const getReadProvider = (): ethers.JsonRpcProvider => {
  if (!readProvider) {
    readProvider = new ethers.JsonRpcProvider(UNIFI_RPC_URL);
  }
  return readProvider;
};
